export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13490.ec2b1e0e.jpg";